
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
// @ is an alias to /src
import store from "@/store";
import SiteLogo from "@/components/SiteLogo.vue";
import ButtonLang from "@/components/button/ButtonLang.vue";
// import { fetchLatest } from '@/services/userService';
import GlobalMenu from "@/components/GlobalMenu/GlobalMenu.vue";

@Component({
  components: {
    SiteLogo,
    ButtonLang,
    GlobalMenu,
  },
})
export default class CommonHeaderJa extends Vue {
  private name = "CommonHeaderJa";

  @Prop({ type: Boolean, default: false })
  readonly hideGlobalMenu!: boolean;

  get isShow(): boolean {
    return store.getters.loaded;
  }
  get userName(): string {
    return store.getters["auth/name"];
  }
  get movie(): string {
    return store.getters["auth/movie"];
  }
  get isLogin(): boolean {
    return !!store.getters["auth/token"];
  }
  get visibleAlignmentAlert(): boolean {
    return this.isLogin
      && !store.getters['auth/isWAlignmentComplete']
      && !store.getters['auth/hideAlignmentAlert'];
  }
  get showAlignmentAlert(): boolean {
    const group = store.getters["auth/group"];
    const whiteList = process.env.VUE_APP_SHOW_REWARDS_CLUB_BUTTON_WHITE_LIST.split(",") || [];
    if (whiteList.includes(group)) {
      return false;
    }
    return this.visibleAlignmentAlert
      && !this.hideGlobalMenu
      && !store.getters['auth/isShareholder'];
  }

  private clickLineAuthLink(): void {
    this.$router.push({
      path: '/line-auth',
      query: {
        from: this.$route.fullPath,
      },
    });
  }

  private clickAlignmentAlertClose(): void {
    store.commit('auth/hideAlignmentAlert');
  }

  @Emit()
  private clickMovieBtn(event: any): void {
    store.commit("movie/open", event.target.href);
  }
}
